module.exports = __webpack_public_path__ + "img/03.d043a69c.jpg";